var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 127,
    viewBox: "0 0 208 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.793 124.916C121.537 126.489 111.559 105.23 62.2509 114.063C22.9331 121.105 6.00661 94.8115 1.11043 78.4764C-1.22639 70.6719 -1.81986 40.1677 19.7555 39.7321C92.9757 38.2317 151.643 -40.8301 186.943 28.3096C201.26 56.3575 223.751 121.335 152.793 124.916Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.515 67.3834L119.512 18.638C116.653 17.0401 113.311 16.5113 110.093 17.1526L12.3324 36.8331C9.6993 37.362 9.13668 40.8727 11.4659 42.2005L101.823 93.804C102.442 94.1528 103.162 94.2654 103.859 94.1191L205.694 72.7508C208.315 72.1994 208.856 68.6886 206.515 67.3721V67.3834Z",
    fill: "#8258F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0887 56.1985C54.4615 47.4891 79.6781 44.2259 109.429 48.9069C139.17 53.5879 162.181 64.4352 160.808 73.1446L155.193 110.964L47.4738 94.0178L53.145 57.9763C53.0212 57.38 52.9987 56.7836 53.0887 56.1985Z",
    fill: "#B397F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.181 110.973C156.55 102.268 133.549 91.4177 103.805 86.7387C74.0613 82.0597 48.8392 85.3235 47.4698 94.0286C46.1004 102.734 69.1022 113.584 98.8458 118.263C128.589 122.942 153.812 119.678 155.181 110.973Z",
    fill: "#3D1E80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.661 29.1365L51.7045 29.0352C50.7255 28.9227 49.7466 28.9114 48.7676 29.0352C43.9291 29.6316 40.6096 31.6457 38.5504 38.9035L26.7467 89.7194L23.1909 88.8079L36.0299 35.7866C37.3689 30.2842 42.1175 26.2783 47.7662 25.8845C47.7662 25.8845 56.8243 25.2431 61.9779 26.8972L52.661 29.1365Z",
    fill: "#3D1E80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9368 107.134L20.4838 106.826C18.7886 106.466 17.7153 104.801 18.0724 103.117L21.65 86.2419C22.0934 84.1504 24.148 82.8146 26.2395 83.2581C28.331 83.7015 29.6668 85.7561 29.2234 87.8475L25.6457 104.722C25.2863 106.418 23.621 107.491 21.9368 107.134Z",
    fill: "#B397F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 46,
    width: 114,
    height: 65
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0887 56.1985C54.4615 47.4891 79.6781 44.2259 109.429 48.9069C139.17 53.5879 162.181 64.4352 160.808 73.1446L155.193 110.964L47.4738 94.0178L53.145 57.9763C53.0212 57.38 52.9987 56.7836 53.0887 56.1985Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.565 69.2625C170.238 68.5199 120.93 52.2714 85.8445 57.8639C56.0932 62.6124 45.9323 74.0336 45.9323 74.0336L51.1871 43.8996L127.265 39.9388L171.565 69.2625Z",
    fill: "#B397F5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.548c0162af124fcec0c6d2b5bd8e7d24.svg";
export { ForwardRef as ReactComponent };